import React, { useContext } from "react";
import Paper from '@mui/material/Paper';
import TopPanel from "../../Components/TopPanel";
import { LogisticStationContext } from "../context";
import { MuiButon } from "../../../../CommonComponents/MuiButton";

export default function LogisticStationOperationHeader({
  _loadingSaveLogisticStation,
  _saveLogisticStation,
}) {
  const { operation, _setLogisticStationData, _logisticStationData, setOperation } =
    useContext(LogisticStationContext);

  const handleSave = () => {
    _saveLogisticStation(
      { data: _logisticStationData },
      ({ data: NewLogisticStationData, success: callStatus }) => {
        if (callStatus) {
          if (operation === "Create") {
          }
          setOperation("Change");
        }
        _setLogisticStationData(NewLogisticStationData);
      }
    );
  };

  return (
    <Paper className="py-2 px-2 d-flex align-items-center justify-space-between customPaper">
      <TopPanel />
      <MuiButon
        title="Save"
        loading={_loadingSaveLogisticStation}
        onClick={handleSave}
        disabled={operation === "Display"}
      />
    </Paper>
  );
}
